import React from "react";
import { Typography } from "antd";

const { Text } = Typography;

// Simple data table for items with fixed body height and sticky header
const ItemDataTable = ({ items, renderRow, height }) => {
  return (
    <div className="co-table-wrapper">
      <div className="co-table-header">
        <div>Sản phẩm</div>
        <div className="co-table-center">SL</div>
        <div className="co-table-right">Giá</div>
      </div>
      <div className="co-table-body" style={{ height, overflowY: 'auto' }}>
        {Array.isArray(items) && items.length ? (
          items.map((it) => (
            <div key={it.productId} className="co-table-row">
              {renderRow(it)}
            </div>
          ))
        ) : (
          <div className="co-table-empty">Chưa có sản phẩm nào được thêm vào</div>
        )}
      </div>
    </div>
  );
};

// Summary table for right column items
const OrderSummaryTable = ({ items, renderRow, height }) => {
  return (
    <div className="co-table-wrapper">
      <div className="co-table-header co-table-header-empty">
        <div></div>
        <div className="co-table-center"></div>
        <div className="co-table-right"></div>
      </div>
      <div className="co-table-body" style={{ height, overflowY: 'auto' }}>
        {Array.isArray(items) && items.length ? (
        items.map((it) => (
          <div key={it.productId} className="co-table-row co-table-row-summary">
            {renderRow(it)}
          </div>
        ))
        ) : (
          <div className="co-table-empty">Chưa có sản phẩm nào</div>
        )}
      </div>
    </div>
  );
};

export { ItemDataTable, OrderSummaryTable };